import axios from 'axios'

export default () => {
  // __API__ = http://api.service.com
  return axios.create({
    baseURL: `https://api.pflegemarkt.com/sks/sks-submit.php?version=default`,
    //baseURL: `https://johanniter-portfolio.de/hausnotruf/api/`,
    timeout: 5000
  })
}



// WEBPACK FOOTER //
// ./src/config/axios_mail.js